import { extractData } from "../../../../utils";
import { API_URL } from "../../../../utils/constant";
import { APIError, handleAPIError } from "../../../common/errorHandler";
import { getDecoratedUrl } from "../../../common/urlService";
import { getApiAsyn, deleteApiAsyn, baseUrl, getAuthHeaders } from "../../../PostAPI";
import axios from "axios";

export const fetchRoles = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.SYSTEM_ROLES.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRoleById = async (payload) => {
  const url = API_URL.SYSTEM_ROLES.GET_BY_ID.replace(":id", payload?.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };

  if (isEdit) {
    return axios.put(baseUrl + url, data, config);
  } else {
    return axios.post(baseUrl + url, data, config);
  }
};

export const updateRole = async (payload) => {
  const url = API_URL.SYSTEM_ROLES.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const createRole = async (payload) => {
  const url = API_URL.SYSTEM_ROLES.CREATE;

  try {
    let result = await dataUploadApi(url, payload);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteRole = async (id) => {
  const url = API_URL.SYSTEM_ROLES.DELETE.replace(":id", id);
  try {
    const result = await deleteApiAsyn(url, null, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRoleMenuAccess = async (payload) => {
  const url = API_URL.SYSTEM_ROLES.GET_MENU_ACCESS.replace(":id", payload?.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    
    // Return the raw array directly
    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
export const fetchAllMenus = async () => {
  const url = API_URL.SYSTEM_ROLES.GET_ALL_MENUS;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};